module.exports = __webpack_public_path__ + "assets/Retina-ExLightItalic.16fe11827a28cbcfa06eb10815498897.woff2";